import { render, staticRenderFns } from "./VoyageTable.vue?vue&type=template&id=8c2e9364&scoped=true&"
import script from "./VoyageTable.vue?vue&type=script&lang=js&"
export * from "./VoyageTable.vue?vue&type=script&lang=js&"
import style0 from "./VoyageTable.vue?vue&type=style&index=0&id=8c2e9364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2e9364",
  null
  
)

export default component.exports